export const generateUniqueId = (): string => {
    const timestamp = (new Date()).getTime().toString(36); // Convert current timestamp to base-36 string
    const randomChars = Math.random().toString(36).substr(2, 8); // Generate random characters
    return timestamp + randomChars; // Concatenate timestamp and random characters
  };
